import React from 'react'
import { fonts, colors } from '../../themes'
import doximity from '../../lib/doximitySDK'
import loginWithDoximity from '../../media/loginDoximity.png'
import verifyWithDoximity from '../../media/verifyDoximity.png'

export default ({ children, style, to, onClick, imageType='login', referralSlug }) => {
  const defaultStyle = {
    width: '100%',
    maxWidth: 250,
    cursor: 'pointer',
  }

  const onClickLocal = () => {
    if (typeof window != 'undefined') {
      const hostname = window.location.hostname
      let href = `https://us-central1-oncallogy-177220.cloudfunctions.net/redirect?source=${hostname}`
      if (referralSlug) {
        href = `${href}?referralSlug=${referralSlug}`
      }
      window.location.href = href
    }
    onClick()
  }

  return (
    <div>
      <img
        src={ imageType === 'login' ? loginWithDoximity : verifyWithDoximity }
        css={{ ...defaultStyle, ...style }}
        onClick={onClickLocal}
      />
    </div>
  )

}


// WEBPACK FOOTER //
// ./src/components/base/doximityLogin.js